




import Base from './Base.vue';

export default Base.extend({
	name: 'TiskKoduWCasu',
	components: {
		BaseFilterSestav: Base,
	},
	mounted() {
		if (!this.dmsSys.EnableTaiwanPrp) {
			this.$nextTick(() => { this.fetchPdf(); });
		}
	},
	methods: {
		fetchPdf() {
			(this.$refs.baseFilter as any).generatePdf();
		},
	},
});
